import { useCallback } from "react";
import { useReactFlow } from "reactflow";

export interface UseSetGraphCenter {
    moveToNode: (nodeId?: string) => void;
}

const useSetGraphCenter = () => {
    const { setCenter, zoomTo, } = useReactFlow();

    const moveToNode = useCallback(
        (nodeId?: string) => {
            if (!nodeId) return;
            const rootNode = document.querySelector<HTMLDivElement>(
                `div[data-id="${nodeId}"]`
            );
            if (rootNode) {
                const styles = window.getComputedStyle(rootNode);
                const matrix = new WebKitCSSMatrix(styles.transform);
                setCenter(
                    matrix.m41 + rootNode.offsetWidth,
                    matrix.m42 + rootNode.offsetHeight
                );
                zoomTo(0);
            }
        },
        [setCenter, zoomTo]
    );

    return {
        moveToNode,
    };
};

export default useSetGraphCenter;
